import { render, staticRenderFns } from "./stress-and-physical-sensations.vue?vue&type=template&id=52f2cbe8&"
import script from "./stress-and-physical-sensations.vue?vue&type=script&lang=js&"
export * from "./stress-and-physical-sensations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports